<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
	name: "App",
	data() {
		return {
			clipped: false,
			drawer: true,
			fixed: false,
			items: [
				{
					icon: "bubble_chart",
					title: "Inspire",
				},
			],
			miniVariant: false,
			right: true,
			rightDrawer: false,
			title: "Vuetify.js",
		};
	},
};
</script>

<style>
* {
	font-family: "LXGW WenKai Screen", sans-serif;
	font-weight: 400;
}
</style>
